module.exports = __webpack_public_path__ + "img/countering-opposition.d7d15648.svg";